// @module Ames.RecentlyViewedItems.RecentlyViewedItems
define('Ames.RecentlyViewedItems.RecentlyViewedItems.View'
,	[
	'ames_recentlyvieweditems_recentlyvieweditems.tpl'
	
	,	'Backbone'
    ]
, function (
	ames_recentlyvieweditems_recentlyvieweditems_tpl
	
	,	Backbone
)
{
    'use strict';

	// @class Ames.RecentlyViewedItems.RecentlyViewedItems.View @extends Backbone.View
	return Backbone.View.extend({

		template: ames_recentlyvieweditems_recentlyvieweditems_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new RecentlyViewedItemsModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Ames.RecentlyViewedItems.RecentlyViewedItems.View.Context
	,	getContext: function getContext()
		{
			//@class Ames.RecentlyViewedItems.RecentlyViewedItems.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
